document.addEventListener("turbolinks:load", function () {
  const paramsToObject = function (entries) {
    const result = {}
    for(const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }
  const urlParams = new URLSearchParams(location.search);
  const data = paramsToObject(urlParams.entries());
  if (!(data["utm_source"] || data["utm_medium"] || data["utm_campaign"])) {
    return;
  }
  data.landing_path = location.pathname;
  data.landing_fullpath = location.pathname + location.search;
  $.ajax({
    url: '/consumer/user_traffic_sources',
    method: 'POST',
    data: {
      user_traffic_source: data
    },
    dataType: 'json'
  });
});
